// Static support page (ticket #25) — the store listings' support URL.
// Convex-free on purpose (renders for signed-out reviewers).
import { Link } from "react-router";

export default function Support() {
  return (
    <main className="mx-auto max-w-2xl px-6 py-12">
      <h1 className="text-3xl font-bold tracking-tight text-ink">
        Support
      </h1>
      <p className="mt-4 text-muted">
        Having trouble with ToDoTogether? We want to hear about it.
      </p>
      <div className="mt-8 space-y-4 text-muted">
        <p>
          <span className="font-semibold">Email:</span>{" "}
          <span className="text-muted">
            [support address — pending, ticket #25]
          </span>
        </p>
        <p>
          <span className="font-semibold">Subscriptions:</span> manage or cancel
          your plan from Settings → Plan in the app, or through your app store
          account.
        </p>
        <p>
          <span className="font-semibold">Deleting your data:</span> you can
          delete your account yourself from Settings → Account; see the{" "}
          <Link
            to="/privacy"
            className="underline hover:text-ink"
          >
            privacy policy
          </Link>{" "}
          for what deletion removes.
        </p>
      </div>
    </main>
  );
}
